import React from "react";
import { Card, CardBody, Badge } from "reactstrap";
import moment from "moment";

class CertificateCard extends React.Component {

  getSkillColor(level) {
    var colors = {
      'Avançado': '#28a745',
      'Intermediário': '#ffc107',
      'Iniciante': '#17a2b8',
      'Não Iniciado': '#6c757d'
    };
    return colors[level] || '#6c757d';
  }

  render() {

    const { certificate } = this.props;
    var courseIcon = certificate.courseIcon || certificate.courseCover || null;

    return (
      <Card
        className="shadow-sm mb-3"
        style={{ cursor: 'pointer', transition: 'transform 0.2s', borderLeft: '4px solid #dc3545' }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        onClick={() => this.props.onClick && this.props.onClick(certificate)}
      >
        <CardBody className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center mr-3"
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '8px',
              backgroundColor: '#f8f9fa',
              border: '2px solid #dc3545',
              flexShrink: 0,
              overflow: 'hidden'
            }}
          >
            {courseIcon ? (
              <img
                src={courseIcon}
                alt="Curso"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<i class="fas fa-graduation-cap" style="font-size:1.5rem;color:#dc3545"></i>';
                }}
              />
            ) : (
              <i className="fas fa-graduation-cap" style={{ fontSize: '1.5rem', color: '#dc3545' }} />
            )}
          </div>
          <div className="flex-grow-1">
            <h5 className="mb-1" style={{ fontSize: '0.95rem' }}>
              {certificate.courseName || 'Certificado de Conclusão'}
            </h5>
            {certificate.classroomName && (
              <small className="text-muted d-block mb-1">
                <i className="fas fa-chalkboard mr-1" />
                {certificate.classroomName}
              </small>
            )}
            <div className="d-flex align-items-center flex-wrap">
              <Badge
                style={{ backgroundColor: this.getSkillColor(certificate.skillLevel), color: '#fff' }}
                className="mr-2 mb-1"
              >
                {certificate.skillLevel || 'Iniciante'}
              </Badge>
              {certificate.averageScore > 0 && (
                <Badge color="primary" className="mr-2 mb-1">
                  Media: {parseFloat(certificate.averageScore).toFixed(1)}
                </Badge>
              )}
              {certificate.totalHours > 0 && (
                <Badge color="info" className="mr-2 mb-1">
                  {parseFloat(certificate.totalHours).toFixed(0)}h
                </Badge>
              )}
            </div>
            <small className="text-muted">
              <i className="fas fa-calendar-alt mr-1" />
              {moment(certificate.completionDate).format('DD/MM/YYYY')}
              <span className="ml-2">
                <i className="fas fa-key mr-1" />
                {certificate.certificateCode}
              </span>
            </small>
          </div>
          <div className="ml-3">
            <i className="fas fa-chevron-right text-muted" />
          </div>
        </CardBody>
      </Card>
    );

  }

}

export default CertificateCard;
